import {
  mdiAccountHardHatOutline,
  mdiAccountOutline,
  mdiAlertOutline,
  mdiArrowLeft,
  mdiArrowRight,
  mdiCalendarOutline,
  mdiCheckBold,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiContentSaveOutline,
  mdiDialpad,
  mdiLoading,
  mdiLogin,
  mdiLogout,
  mdiMinus,
  mdiOfficeBuildingMarker,
  mdiPackageVariantClosed,
  mdiPencil,
  mdiPlus,
  mdiSync,
  mdiTransfer,
  mdiTrashCanOutline,
  mdiUnfoldMoreHorizontal,
} from '@mdi/js';

class Icons {
  public static readonly Core = class {
    static readonly Close: string = mdiClose;
    static readonly Confirm: string = mdiCheckBold;
    static readonly Create: string = mdiPlus;
    static readonly Date: string = mdiCalendarOutline;
    static readonly Delete: string = mdiTrashCanOutline;
    static readonly Edit: string = mdiPencil;
    static readonly Left: string = mdiArrowLeft;
    static readonly Loading: string = mdiLoading;
    static readonly Minus: string = mdiMinus;
    static readonly Plus: string = mdiPlus;
    static readonly Right: string = mdiArrowRight;
    static readonly Save: string = mdiContentSaveOutline;
    static readonly Warning: string = mdiAlertOutline;
  };

  public static readonly Sort = class {
    static readonly Asc: string = mdiChevronUp;
    static readonly Desc: string = mdiChevronDown;
    static readonly Sortable: string = mdiUnfoldMoreHorizontal;
  };

  public static readonly Pagination = class {
    static readonly Previous: string = mdiChevronLeft;
    static readonly Next: string = mdiChevronRight;
  };

  static readonly Employee: string = mdiAccountOutline;
  static readonly Foreman: string = mdiAccountHardHatOutline;
  static readonly Hardware: string = mdiPackageVariantClosed;
  static readonly Login: string = mdiLogin;
  static readonly Logout: string = mdiLogout;
  static readonly Movement: string = mdiTransfer;
  static readonly PinLogin: string = mdiDialpad;
  static readonly Project: string = mdiOfficeBuildingMarker;
  static readonly Sync: string = mdiSync;
}

export default Icons;
